import { render, staticRenderFns } from "./ncbj.vue?vue&type=template&id=0dae8e76&scoped=true"
import script from "./ncbj.vue?vue&type=script&lang=js"
export * from "./ncbj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dae8e76",
  null
  
)

export default component.exports